import React from "react";
import "./EditorLeftMenuOutpaintControls.css";
import AiOutpaintControlMenu from "./AiOutpaintControlMenu";

const EditorLeftMenuOutpaintControls = ({
  onApplyOutpaint,
  busy = false,
  error = null,
}) => {
  return (
    <div className="ai-outpaint-controls-container">
      <h1>AI Expand</h1>
      {error ? (
        <p className="ai-outpaint-controls-error">{error}</p>
      ) : null}
      <AiOutpaintControlMenu onApply={onApplyOutpaint} busy={busy} />
    </div>
  );
};

export default EditorLeftMenuOutpaintControls;
